import { LINKS } from "../../config/links";

const PRODUCTS = [
  {
    id: "content-marketing",
    eyebrow: "Content Strategy",
    name: "A Beginner's Guide to Content Marketing",
    description:
      "Create content that builds trust, grows your audience, and converts attention into opportunity.",
    cta: {
      label: "Learn Content Strategy",
      href: LINKS.contentMarketingGuide,
      testid: "marketing-cta-content",
    },
  },
  {
    id: "financial-plan",
    eyebrow: "Wealth Building",
    name: "A Digital Marketer's Financial Plan",
    description:
      "Long-term wealth strategies for entrepreneurs and digital marketers building nontraditional income.",
    cta: {
      label: "Plan Your Financial Future",
      href: LINKS.digitalMarketerFinancialPlan,
      testid: "marketing-cta-financial",
    },
  },
  {
    id: "email-list",
    eyebrow: "Audience Growth",
    name: "Build Your Email List Fast",
    description:
      "Grow an audience you actually own — not just followers borrowed from social media platforms.",
    cta: {
      label: "Start Growing Your List",
      href: LINKS.emailListFast,
      testid: "marketing-cta-email",
    },
  },
];

export default function MarketingAddons() {
  return (
    <section
      id="marketing-addons"
      data-testid="marketing-addons-section"
      className="relative py-24 sm:py-32 border-y border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="max-w-3xl mb-14">
          <div className="reveal flex items-center gap-3 mb-6">
            <span className="h-[1px] w-10 bg-amber-500/70" />
            <span className="font-sans-body uppercase text-[11px] tracking-[0.32em] text-amber-400">
              Marketing Add-Ons
            </span>
          </div>
          <h2
            data-testid="marketing-addons-headline"
            className="reveal font-display font-light text-white text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] tracking-[-0.01em] text-balance"
            style={{ transitionDelay: "80ms" }}
          >
            Build your brand &{" "}
            <span className="italic text-amber-400">your audience.</span>
          </h2>
          <p
            className="reveal mt-5 text-slate-300 text-base sm:text-lg leading-relaxed"
            style={{ transitionDelay: "140ms" }}
          >
            Resources designed to increase visibility, build trust, and
            create long-term audience growth — without burning out.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {PRODUCTS.map((p, i) => (
            <div
              key={p.id}
              data-testid={`marketing-addons-card-${p.id}`}
              className="reveal group bg-[#0e1e44]/70 border border-white/10 hover:border-amber-500/40 p-7 lg:p-8 flex flex-col transition-all duration-400 hover:-translate-y-1"
              style={{ transitionDelay: `${120 + i * 90}ms` }}
            >
              <div className="flex items-center justify-between mb-5">
                <span className="font-sans-body uppercase text-[10px] tracking-[0.3em] text-amber-400">
                  {p.eyebrow}
                </span>
                <span className="font-display text-lg text-slate-500">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-display text-2xl text-white leading-tight">
                {p.name}
              </h3>
              <p className="mt-3 text-sm text-slate-300 leading-relaxed flex-1">
                {p.description}
              </p>
              <a
                href={p.cta.href}
                data-testid={p.cta.testid}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center justify-center gap-3 border border-white/20 hover:border-amber-400/70 hover:bg-amber-500/10 text-white hover:text-amber-300 px-6 py-3.5 text-[11px] uppercase tracking-[0.18em] font-semibold transition-all duration-300"
              >
                {p.cta.label}
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M13 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
